<template>
  <div class="job-topbar">
    <div class="topbar-container">
      <!-- 搜索 -->
      <div class="search-wrapper">
        <input
          type="text"
          placeholder="请输入职务名称"
          class="search-input"
          v-model="jobName"
          @keyup.enter="searchjob"
        />
        <button class="search-confirm-button" @click="searchjob">搜索</button>
      </div>
    </div>
    <div class="btns">
      <div class="add" @click="add" v-hasPermi="'sc:schooljob:add'">增加职务</div>
      <!-- <div class="add" @click="batchDelete">批量删除</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["deleteList"],
  data() {
    return {
      // 学生名搜索
      jobName: "",
    };
  },
  created() {},
  methods: {
    // 批量删除
    batchDelete() {
      // console.log(this.deleteList);
      if (!this.deleteList.length)
        return this.$message.warning("请选择需要删除的数据项!");
      this.$confirm("是否删除选中的数据项?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {})
        .catch(() => {});
    },
    add() {
      this.$emit("addjobShowSwitch", true);
    },
    // 搜索学生姓名
    searchjob() {
      this.$emit("searchjob", this.jobName);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./jobManageTopbar.scss";
</style>
